import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$background",
  },
  card: {
    backgroundColor: "$survey_card",
  },
  loader: {
    color: "$question_text",
  },
  container: {
    alignItems: "center",
  },
  text: {
    fontSize: "$h3",
    marginTop: "5vh",
    textAlign: "center",
    color: "$question_text",
  },
  tiles: {
    backgroundColor: "$question_text",
  },
  tilesText: {
    color: "$survey_card",
  },
  errorIcon: {
    color: "#ccc",
    fontSize: 150,
  },
  errorIconLabel: {
    color: "#ccc",
    fontSize: "$h5",
  },
  errorMessage: {
    margin: 20,
    fontSize: "$h3",
    textAlign: "center",
    color: "$question_text",
  },
});
